import { Navigate, RouteObject } from 'react-router-dom'
import OperatorLayout from './components/AgentLayout'
import ManageMemberPage from '../manage-member/pages/ManageMemberPage'
import MemberGroupListPage from '../manage-member/pages/MemberGroupListPage'
import MemberLoginLogPage from '../manage-member/pages/MemberLoginLogPage'
import EventLogPage from '../manage-member/pages/EventLogPage'
import DashboardPage from '../dashboard/pages/OverallAnalyticPage'
import GraphSummaryPage from '../dashboard/pages/GraphSummaryPage'
import GetPlayerListPage from '../manage-player/pages/GetPlayerListPage'
import GetChannelPage from '../manage-player/pages/GetChannelPage'
import BannedPlayerPage from '../manage-player/pages/BannedPlayerPage'
import InactivePlayerPage from '../manage-player/pages/InactivePlayerPage'
import CreateGroupPage from '../manage-member/pages/CreateGroupPage'
import EditGroupPage from '../manage-member/pages/EditGroupPage'
import CreateMemberPage from '../manage-member/pages/CreateMemberPage'
import EditMemberPage from '../manage-member/pages/EditMemberPage'
import DepositPromotionPage from '../promotion/pages/DepositPromotionPage'
import CreateDepositPromotionPage from '../promotion/pages/CreateDepositPromotionPage'
import EditDepositPromotionPage from '../promotion/pages/EditDepositPromotionPage'
import CommissionPage from '../promotion/pages/CommisisonPage'
import CreateCommissionPage from '../promotion/pages/CreateCommissionPage'
import EditCommissionPage from '../promotion/pages/EditCommissionPage'
import ReturnLossPage from '../promotion/pages/ReturnLossPage'
import CreateReturnLossPage from '../promotion/pages/CreateReturnLossPage'
import EditReturnLossPage from '../promotion/pages/EditReturnLossPage'
import DailyPlayerReturnLossPage from '../promotion/pages/DailyPlayerReturnLossPage'
import ReturnLossHistoryPage from '../promotion/pages/ReturnLossHistoryPage'
import DailyCheckInPage from '../promotion/pages/DailyCheckInPage'
import RankPage from '../manage-rank/pages/RankPage'
import CreateRankPage from '../manage-rank/pages/CreateRankPage'
import LuckyWheelPage from '../promotion/pages/LuckyWheelPage'
import UpdateLuckyWheelPage from '../promotion/pages/UpdateLuckyWheelPage'
import InviteFriendPage from '../promotion/pages/InviteFriendPage'
import InviteFriendCommissionHistoryPage from '../promotion/pages/InviteFriendCommissionHistoryPage'
import CarouselPage from '../client-setting/pages/CarouselPage'
import GameListPage from '../game/pages/GameListPage'
import LoginAnnouncePage from '../client-setting/pages/LoginAnnouncePage'
import GeneralSettingPage from '../client-setting/pages/GeneralSettingPage'
import WebsiteBrandingPage from '../client-setting/pages/WebsiteBrandingPage'
import TransactionSettingPage from '../client-setting/pages/TransactionSettingPage'
import ContactBankSettingPage from '../client-setting/pages/ContactBankSettingPage'
import SlideAnnouncementPage from '../client-setting/pages/SlideAnnouncementPage'
import ProfilePageBannerPage from '../client-setting/pages/ProfilePageBannerPage'
import BrokeNotificationPage from '../client-setting/pages/BrokeNotificationPage'
import ChannelAnalyticPage from '../dashboard/pages/ChannelAnalyticPage'
import BankAccountPage from '../bank/pages/BankAccountPage'
import CreateBankAccountPage from '../bank/pages/CreateBankAccountPage'
import UpdateBankAccountPage from '../bank/pages/UpdateBankAccountPage'
import AnnouncementPage from '../announcement/pages/AnnouncementPage'
import CreateAnnouncementPage from '../announcement/pages/CreateAnnouncementPage'
import UpdateAnnouncementPage from '../announcement/pages/UpdateAnnouncementPage'
import GameTypeSettingPage from '../client-setting/pages/GameTypeSettingPage'
import PartnerPage from '../manage-player/pages/PartnerPage'
import CreatePartnerPage from '../manage-player/pages/CreatePartnerPage'
import EditPartnerPage from '../manage-player/pages/EditPartnerPage'
import PartnerPlayersPage from '../manage-player/pages/PartnerPlayersPage'
import PartnerPaymentsPage from '../manage-player/pages/PartnerPaymentsPage'
import UpdateRankPage from '../manage-rank/pages/UpdateRankPage'
import RankSettingsPage from '../manage-rank/pages/RankSettingsPage'
import CreateDailyCheckInPage from '../promotion/pages/CreateDailyCheckInPage'
import EditDailyCheckInPage from '../promotion/pages/EditDailyCheckInPage'
import WithdrawPage from '../transaction/pages/WithdrawPage'
import DepositPage from '../transaction/pages/DepositPage'
import TrueWalletLogsPage from '../transaction/pages/TrueWalletLogsPage'
import SmsAutoLogsPage from '../transaction/pages/SmsAutoLogsPage'
import TransactionStatisticsPage from '../transaction/pages/TransactionStatisticsPage'
import PaymentGatewayPage from '../bank/pages/PaymentGatewayPage'
import CreatePaymentGatewayPage from '../bank/pages/CreatePaymentGatewayPage'
import ProviderPage from '../game/pages/ProviderPage'
import GameTypeListPage from '../game/pages/GameTypePage'
import OverallAnalyticPage from '../dashboard/pages/OverallAnalyticPage'
import LineAnalyticsPage from '../dashboard/pages/LineAnalyticsPage'
import ActiveUsersPage from '../dashboard/pages/ActiveUsersPage'
import ProfilePage from '../profile/pages/ProfilePage'
import PlayerDetailPage from '../manage-player/pages/PlayerDetailPage'
import DepositByIdPage from '../transaction/pages/DepositByIdPage'
import WithdrawByIdPage from '../transaction/pages/WithdrawByIdPage'
import ActivePlayerListPage from '../manage-player/pages/ActivePlayerListPage'
import ChannelSummaryPage from '../dashboard/pages/ChannelSummaryPage'
import PlayerWithDepositPage from '../manage-player/pages/PlayerWithDepositPage'
import PlayerWithDepositPromotionPage from '../manage-player/pages/PlayerWithDepositPromotionPage'
import DynamicSectionPage from '../client-setting/pages/DynamicSectionPage'
import EditDynamicSectionPage from '../client-setting/pages/EditDynamicSectionPage'
import CreateDynamicSectionPage from '../client-setting/pages/CreateDynamicSectionPage'
import DynamicPage from '../client-setting/pages/DynamicPage'
import DynamicPageById from '../client-setting/pages/DynamicPageById'
import DynamicPagePresetsPage from '../client-setting/pages/DynamicPagePresetsPage'
import PlayerWithDepositPromotionDirectPage from '../manage-player/pages/PlayerWithDepositPromotionDirectPage'
import PlayerWithDepositDirectPage from '../manage-player/pages/PlayerWithDepositDirectPage'
import ActivePlayerListDirectPage from '../manage-player/pages/ActivePlayerListDirectPage'
import PlayerWithWithdrawPage from '../manage-player/pages/PlayerWithWithdrawPage'
import PlayerWithWithdrawDirectPage from '../manage-player/pages/PlayerWithWithdrawDirectPage'
import PlayerWithLuckyWheelReceivePage from '../manage-player/pages/PlayerWithLuckyWheelReceivePage'
import PlayerWithReturnLossReceivePage from '../manage-player/pages/PlayerWithReturnLossReceivePage'
import PlayerWithDailyCheckInReceivePage from '../manage-player/pages/PlayerWithDailyCheckInReceivePage'
import CouponPage from '../batches/pages/BatchPage'
import BatchCouponsPage from '../batches/pages/BatchCouponsPage'
import UsageHistoryPage from '../batches/pages/UsageHistoryPage'
import PlayerDataListPage from '../manage-player/pages/PlayerDataListPage'
import PromotionAnalyticsPage from '../dashboard/pages/PromotionAnalyticsPage'
import PromotionDetailPage from '../dashboard/pages/PromotionDetailPage'
import PlayerWithDepositsWithoutPromotionPage from '../manage-player/pages/PlayerWithDepositsWithoutPromotionPage'
import EventsPage from '../events/pages/EventsPage'
import CreateEventPage from '../events/pages/CreateEventPage'
import UpdateEventPage from '../events/pages/UpdateEventPage'
import EventClaimsPage from '../events/pages/EventClaimsPage'
import RegisteredPlayerPage from '../manage-player/pages/RegisteredPlayerPage'
import MainWalletSettingPage from '../client-setting/pages/MainWalletSettingPage'
import { messagingRoutes } from '../messaging/routes'
import { chatRoutes } from '../chat/routes'
import settingsRoutes from '../settings/routes'
import { lineMessageLogRoutes } from '../line-message-log/routes'
import transactionSettingsRoutes from '../transaction-settings/routes'

// Shop module imports
import ShopItemsPage from '../shop/pages/ShopItemsPage'
import CreateShopItemPage from '../shop/pages/CreateShopItemPage'
import EditShopItemPage from '../shop/pages/EditShopItemPage'
import PurchasesPage from '../shop/pages/PurchasesPage'
import PendingPurchasesPage from '../shop/pages/PendingPurchasesPage'
import PurchaseDetailPage from '../shop/pages/PurchaseDetailPage'

// Tournament module imports
import TournamentsPage from '../tournament/pages/TournamentsPage'
import CreateTournamentPage from '../tournament/pages/CreateTournamentPage'
import EditTournamentPage from '../tournament/pages/EditTournamentPage'
import TournamentPlayersPage from '../tournament/pages/TournamentPlayersPage'

// Retention Analytics imports
import RetentionAnalyticsPage from '../retention-analytics/pages/RetentionAnalyticsPage'

// Blacklist imports
import BlacklistPage from '../blacklist/pages/BlacklistPage'

// Play Logs imports
import PlayLogsPage from '../dashboard/pages/PlayLogsPage'
import PlayerGameStatsPage from '../dashboard/pages/PlayerGameStatsPage'
import OperatorDepositPage from '../bank/pages/OperatorDepositPage'
import OperatorWithdrawalPage from '../bank/pages/OperatorWithdrawalPage'
import PaymentGatewayAnalyticsPage from '../bank/pages/PaymentGatewayAnalyticsPage'
import CryptoInvoicesPage from '../crypto-invoices/pages/CryptoInvoicesPage'

// Domain Management
import ManageDomainsPage from '../admin/pages/ManageDomainsPage'

// Session Management imports
import SessionManagementPage from '../session/pages/SessionManagementPage'

// Telegram Notify imports
import TelegramNotifyPage from '../telegram-notify/pages/TelegramNotifyPage'

// System Metrics imports
import SystemMetricsPage from '../system-metrics/pages/SystemMetricsPage'

// Tags imports
import PlayerTagsPage from '../tags/pages/PlayerTagsPage'
import PlayersWithTagsPage from '../tags/pages/PlayersWithTagsPage'

// OTP Provider imports
import OtpProvidersPage from '../otp-provider/pages/OtpProvidersPage'
import CreateOtpProviderPage from '../otp-provider/pages/CreateOtpProviderPage'
import EditOtpProviderPage from '../otp-provider/pages/EditOtpProviderPage'

// Quota imports
import QuotaPage from '../quota/pages/QuotaPage'

const operatorRoutes: RouteObject = {
	path: '/operator',
	element: <OperatorLayout />,
	children: [
		{
			index: true,
			element: <Navigate to="/operator/home-page" />,
		},
		{
			path: '/operator/home-page',
			element: <AnnouncementPage />,
		},
		{
			path: '/operator/home-page/create-announcement',
			element: <CreateAnnouncementPage />,
		},
		{
			path: '/operator/home-page/:id',
			element: <UpdateAnnouncementPage />,
		},
		{
			path: '/operator/events',
			element: <EventsPage />,
		},
		{
			path: '/operator/events/create-event',
			element: <CreateEventPage />,
		},
		{
			path: '/operator/events/:id',
			element: <UpdateEventPage />,
		},
		{
			path: '/operator/events/:id/claims',
			element: <EventClaimsPage />,
		},
		{
			path: '/operator/manage-member',
			element: <ManageMemberPage />,
		},
		{
			path: '/operator/member-group-list',
			element: <MemberGroupListPage />,
		},
		{
			path: '/operator/member-group-list/:id',
			element: <EditGroupPage />,
		},
		{
			path: '/operator/member-login-log',
			element: <MemberLoginLogPage />,
		},
		{
			path: '/operator/event-log',
			element: <EventLogPage />,
		},
		{
			path: '/operator/dashboard',
			element: <DashboardPage />,
		},
		{
			path: '/operator/graph-summary',
			element: <GraphSummaryPage />,
		},
		{
			path: '/operator/get-player-list',
			element: <GetPlayerListPage />,
		},
		{
			path: '/operator/get-channel',
			element: <GetChannelPage />,
		},
		{
			path: '/operator/banned-player',
			element: <BannedPlayerPage />,
		},
		{
			path: '/operator/inactive-player',
			element: <InactivePlayerPage />,
		},
		{
			path: '/operator/registered-players',
			element: <RegisteredPlayerPage />,
		},
		{
			path: '/operator/member-group-list/create-group',
			element: <CreateGroupPage />,
		},
		{
			path: '/operator/manage-member/create-member',
			element: <CreateMemberPage />,
		},
		{
			path: '/operator/manage-member/:id',
			element: <EditMemberPage />,
		},
		{
			path: '/operator/deposit-promotion',
			element: <DepositPromotionPage />,
		},
		{
			path: '/operator/deposit-promotion/create-promotion',
			element: <CreateDepositPromotionPage />,
		},
		{
			path: '/operator/deposit-promotion/:id',
			element: <EditDepositPromotionPage />,
		},
		{
			path: '/operator/commission',
			element: <CommissionPage />,
		},
		{
			path: '/operator/commission/create-commission',
			element: <CreateCommissionPage />,
		},
		{
			path: '/operator/commission/:id',
			element: <EditCommissionPage />,
		},
		{
			path: '/operator/return-loss',
			element: <ReturnLossPage />,
		},
		{
			path: '/operator/return-loss/create-return-loss',
			element: <CreateReturnLossPage />,
		},
		{
			path: '/operator/return-loss/:id',
			element: <EditReturnLossPage />,
		},
		{
			path: '/operator/return-loss/daily-player-return-loss',
			element: <DailyPlayerReturnLossPage />,
		},
		{
			path: '/operator/return-loss/history',
			element: <ReturnLossHistoryPage />,
		},
		{
			path: '/operator/daily-check-in',
			element: <DailyCheckInPage />,
		},
		{
			path: '/operator/daily-check-in/create-daily-check-in',
			element: <CreateDailyCheckInPage />,
		},
		{
			path: '/operator/daily-check-in/:id',
			element: <EditDailyCheckInPage />,
		},
		{
			path: '/operator/rank',
			element: <RankPage />,
		},
		{
			path: '/operator/rank/create-rank',
			element: <CreateRankPage />,
		},
		{
			path: '/operator/rank/:id',
			element: <UpdateRankPage />,
		},
		{
			path: '/operator/rank-settings',
			element: <RankSettingsPage />,
		},
		{
			path: '/operator/lucky-wheel',
			element: <LuckyWheelPage />,
		},
		{
			path: '/operator/lucky-wheel/update',
			element: <UpdateLuckyWheelPage />,
		},
		{
			path: '/operator/invite-friend',
			element: <InviteFriendPage />,
		},
		{
			path: '/operator/invite-friend/commission-history',
			element: <InviteFriendCommissionHistoryPage />,
		},
		{
			path: '/operator/carousel',
			element: <CarouselPage />,
		},

		{
			path: '/operator/game-list',
			element: <GameListPage />,
		},
		{
			path: '/operator/login-announce',
			element: <LoginAnnouncePage />,
		},
		{
			path: '/operator/general-setting',
			element: <GeneralSettingPage />,
		},
		{
			path: '/operator/website-branding',
			element: <WebsiteBrandingPage />,
		},
		{
			path: '/operator/transaction-setting',
			element: <TransactionSettingPage />,
		},
		{
			path: '/operator/contact-setting',
			element: <ContactBankSettingPage />,
		},
		{
			path: '/operator/slide-announcement',
			element: <SlideAnnouncementPage />,
		},
		{
			path: '/operator/profile-page-banner',
			element: <ProfilePageBannerPage />,
		},
		{
			path: '/operator/channel-analytic',
			element: <ChannelAnalyticPage />,
		},
		{
			path: '/operator/channel-analytic/:channelId',
			element: <ChannelSummaryPage />,
		},
		{
			path: '/operator/overall-analytic',
			element: <OverallAnalyticPage />,
		},
		{
			path: '/operator/line-analytics',
			element: <LineAnalyticsPage />,
		},
		{
			path: '/operator/active-users',
			element: <ActiveUsersPage />,
		},
		{
			path: '/operator/bank-account',
			element: <BankAccountPage />,
		},
		{
			path: '/operator/bank-account/create-bank-account',
			element: <CreateBankAccountPage />,
		},
		{
			path: '/operator/bank-account/:id',
			element: <UpdateBankAccountPage />,
		},
		{
			path: '/operator/game-type-setting',
			element: <GameTypeSettingPage />,
		},
		{
			path: '/operator/partner',
			element: <PartnerPage />,
		},
		{
			path: '/operator/get-player-list/create-partner/:id',
			element: <CreatePartnerPage />,
		},
		{
			path: '/operator/partner/:id',
			element: <EditPartnerPage />,
		},
		{
			path: '/operator/partner/:id/players',
			element: <PartnerPlayersPage />,
		},
		{
			path: '/operator/partner-payments',
			element: <PartnerPaymentsPage />,
		},
		{
			path: '/operator/get-player-list/create-partner',
			element: <Navigate to="/operator/get-player-list" />,
		},
		{
			path: '/operator/transactions',
			children: [
				{
					path: '/operator/transactions/deposits',
					element: <DepositPage />,
				},
				{
					path: '/operator/transactions/withdraws',
					element: <WithdrawPage />,
				},
				{
					path: '/operator/transactions/true-wallet-logs',
					element: <TrueWalletLogsPage />,
				},
				{
					path: '/operator/transactions/sms-auto-logs',
					element: <SmsAutoLogsPage />,
				},
				{
					path: '/operator/transactions/statistics',
					element: <TransactionStatisticsPage />,
				},
			],
		},
		{
			path: '/operator/payment-gateway',
			element: <PaymentGatewayPage />,
		},
		{
			path: '/operator/payment-gateway/create-payment-gateway',
			element: <CreatePaymentGatewayPage />,
		},
		{
			path: '/operator/payment-gateway/:id',
			element: <CreatePaymentGatewayPage />,
		},
		{
			path: '/operator/provider-list',
			element: <ProviderPage />,
		},
		{
			path: '/operator/game-type',
			element: <GameTypeListPage />,
		},
		{
			path: '/operator/profile',
			element: <ProfilePage />,
		},
		{
			path: '/operator/get-player-list/player-detail/:id',
			element: <PlayerDetailPage />,
		},
		{
			path: '/operator/get-player-list/player-detail',
			element: <Navigate to="/operator/get-player-list" />,
		},
		{
			path: '/operator/transactions/deposits/:id',
			element: <DepositByIdPage />,
		},
		{
			path: '/operator/transactions/withdraws/:id',
			element: <WithdrawByIdPage />,
		},
		{
			path: '/operator/get-player-list/active-player',
			element: <ActivePlayerListPage />,
		},
		{
			path: '/operator/get-player-list/player-with-deposit',
			element: <PlayerWithDepositPage />,
		},
		{
			path: '/operator/get-player-list/player-with-deposit-promotion',
			element: <PlayerWithDepositPromotionPage />,
		},
		{
			path: '/operator/get-player-list/player-with-deposits-without-promotion',
			element: <PlayerWithDepositsWithoutPromotionPage />,
		},
		{
			path: '/operator/player-with-deposit-promotion',
			element: <PlayerWithDepositPromotionDirectPage />,
		},
		{
			path: '/operator/dynamic-section',
			element: <DynamicSectionPage />,
		},
		{
			path: '/operator/dynamic-section/:id',
			element: <EditDynamicSectionPage />,
		},
		{
			path: '/operator/dynamic-section/create-dynamic-section',
			element: <CreateDynamicSectionPage />,
		},
		{
			path: '/operator/dynamic-section/create-dynamic-section',
			element: <Navigate to="/operator/dynamic-section" />,
		},
		{
			path: '/operator/dynamic-page-presets',
			element: <DynamicPagePresetsPage />,
		},
		{
			path: '/operator/dynamic-page',
			element: <DynamicPage />,
		},
		{
			path: '/operator/dynamic-page/:id',
			element: <DynamicPageById />,
		},
		{
			path: '/operator/player-with-deposit-promotion',
			element: <PlayerWithDepositPromotionDirectPage />,
		},
		{
			path: '/operator/player-with-deposit',
			element: <PlayerWithDepositDirectPage />,
		},
		{
			path: '/operator/active-player-list',
			element: <ActivePlayerListDirectPage />,
		},
		{
			path: '/operator/player-with-withdraw',
			element: <PlayerWithWithdrawDirectPage />,
		},
		{
			path: '/operator/get-player-list/player-with-withdraw',
			element: <PlayerWithWithdrawPage />,
		},
		{
			path: '/operator/get-player-list/player-with-lucky-wheel-receive',
			element: <PlayerWithLuckyWheelReceivePage />,
		},
		{
			path: '/operator/get-player-list/player-with-return-loss-receive',
			element: <PlayerWithReturnLossReceivePage />,
		},
		{
			path: '/operator/get-player-list/player-with-daily-check-in-receive',
			element: <PlayerWithDailyCheckInReceivePage />,
		},
		{
			path: '/operator/get-player-data',
			element: <PlayerDataListPage />,
		},
		{
			path: '/operator/coupons',
			element: <CouponPage />,
		},
		{
			path: '/operator/coupons/:id',
			element: <BatchCouponsPage />,
		},
		{
			path: '/operator/coupons/:couponId/usage-history',
			element: <UsageHistoryPage />,
		},

		{
			path: '/operator/promotion-analytic',
			element: <PromotionAnalyticsPage />,
		},
		{
			path: '/operator/analytics/promotion/detail/:promotionId',
			element: <PromotionDetailPage />,
		},
		{
			path: '/operator/retention-analytics',
			element: <RetentionAnalyticsPage />,
		},
		{
			path: '/operator/play-logs',
			element: <PlayLogsPage />,
		},
		{
			path: '/operator/player-game-stats',
			element: <PlayerGameStatsPage />,
		},
		{
			path: '/operator/blacklist',
			element: <BlacklistPage />,
		},
		{
			path: '/operator/payment-gateway/deposits',
			element: <OperatorDepositPage />,
		},
		{
			path: '/operator/payment-gateway/withdrawals',
			element: <OperatorWithdrawalPage />,
		},
		{
			path: '/operator/bank-overview',
			element: <PaymentGatewayAnalyticsPage />,
		},
		{
			path: '/operator/broke-notification',
			element: <BrokeNotificationPage />,
		},
		{
			path: '/operator/main-wallet-setting',
			element: <MainWalletSettingPage />,
		},
		{
			path: '/operator/crypto-invoices',
			element: <CryptoInvoicesPage />,
		},
		{
			path: '/operator/system-metrics',
			element: <SystemMetricsPage />,
		},
		{
			path: '/operator/session-management',
			element: <SessionManagementPage />,
		},
		{
			path: '/operator/telegram-notify',
			element: <TelegramNotifyPage />,
		},
		// Tags routes
		{
			path: '/operator/tags',
			element: <PlayerTagsPage />,
		},
		{
			path: '/operator/tags/players',
			element: <PlayersWithTagsPage />,
		},
		// OTP Provider routes
		{
			path: '/operator/otp-provider',
			children: [
				{
					path: '/operator/otp-provider',
					element: <OtpProvidersPage />,
				},
				{
					path: '/operator/otp-provider/create',
					element: <CreateOtpProviderPage />,
				},
				{
					path: '/operator/otp-provider/:id/edit',
					element: <EditOtpProviderPage />,
				},
			],
		},
		// Quota route
		{
			path: '/operator/quota',
			element: <QuotaPage />,
		},
		// Shop routes
		{
			path: '/operator/shop',
			children: [
				{
					path: '/operator/shop/items',
					element: <ShopItemsPage />,
				},
				{
					path: '/operator/shop/items/create',
					element: <CreateShopItemPage />,
				},
				{
					path: '/operator/shop/items/:id/edit',
					element: <EditShopItemPage />,
				},
				{
					path: '/operator/shop/purchases',
					element: <PurchasesPage />,
				},
				{
					path: '/operator/shop/purchases/pending',
					element: <PendingPurchasesPage />,
				},
				{
					path: '/operator/shop/purchases/:id',
					element: <PurchaseDetailPage />,
				},
			],
		},
		// Tournament routes
		{
			path: '/operator/tournaments',
			children: [
				{
					path: '/operator/tournaments',
					element: <TournamentsPage />,
				},
				{
					path: '/operator/tournaments/create',
					element: <CreateTournamentPage />,
				},
				{
					path: '/operator/tournaments/:id/edit',
					element: <EditTournamentPage />,
				},
				{
					path: '/operator/tournaments/:id/players',
					element: <TournamentPlayersPage />,
				},
			],
		},
		...messagingRoutes.map((route) => ({
			...route,
			path: `/operator/${route.path}`,
		})),
		...chatRoutes.map((route) => ({
			...route,
			path: `/operator/${route.path}`,
		})),
		...lineMessageLogRoutes.map((route) => ({
			...route,
			path: `/operator/${route.path}`,
		})),
		{
			path: '/operator/manage-domains',
			element: <ManageDomainsPage />,
		},
		...settingsRoutes,
		...transactionSettingsRoutes,
	],
}

export default operatorRoutes
